import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { consumeRedirect } from "@/lib/authRedirect";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Ecran intermediar: preia session_id din URL după login-ul Google,
// îl schimbă (prin backend) pe o sesiune, apoi duce la aplicație.
export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");

    (async () => {
      try {
        const r = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setUser(r.data);
        navigate(consumeRedirect(), { replace: true, state: { user: r.data } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="h-8 w-8 text-emerald-600 animate-spin" />
    </div>
  );
}
